import style from './../../adminSect.module.scss';

const UserDataFields = (userData) => {
  const { defaultCursor } = style;

  const getPlaceHolder = (field) => {
    if (userData.pharmacy) {
      return userData.pharmacy[field];
    } else {
      return '';
    }
  };

  const fields = [
    {
      item: {
        label: 'Número de cuenta',
        name: 'accountNumber',
      },
      input: {
        placeholder: userData.accountNumber,
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre de la farmácia',
        name: 'name',
      },
      input: {
        placeholder: getPlaceHolder('name'),
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre del dueño',
        name: 'owner',
      },
      input: {
        placeholder: getPlaceHolder('owner'),
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Número de teléfono',
        name: 'cellPhone',
      },
      input: {
        placeholder: getPlaceHolder('cellPhone'),
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Número de teléfono del responsable de compras',
        name: 'responsibleCellPhone',
      },
      input: {
        placeholder: getPlaceHolder('responsibleCellPhone'),
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre del responsable de compras',
        name: 'nameResponsible',
      },
      input: {
        placeholder: getPlaceHolder('nameResponsible'),
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Email',
        name: 'email',
      },
      input: {
        placeholder: getPlaceHolder('email'),
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Rol',
        name: 'role',
      },
      input: {
        placeholder: userData.role === 'pharmacy' ? 'Farmacia' : '',
        disabled: true,
        className: defaultCursor,
      },
      inputTag: 'Input',
    },
  ];
  return fields;
};

export default UserDataFields;
